import React from 'react';
import { CheckCircle2 } from 'lucide-react';

interface ChecklistItemProps {
  text: string;
  checked?: boolean;
}

export default function ChecklistItem({ text, checked = true }: ChecklistItemProps) {
  return (
    <div className="flex items-start gap-3">
      <CheckCircle2
        className={`h-5 w-5 flex-shrink-0 mt-0.5 ${
          checked ? 'text-blue-600 dark:text-blue-400' : 'text-gray-300 dark:text-gray-600'
        }`}
      />
      <p className="text-gray-700 dark:text-gray-300 text-sm leading-relaxed">{text}</p>
    </div>
  );
}
